import React, { Component } from "react";
import { Icon } from "../../../components/Icon";

const TAB_STEP_PX = 32;


/** ---------- Toolbar (class) ---------- */
export class EditorToolbar extends Component {
    state = { showSaved: false, showCommitted: false };
    _savedTimer = null;
    _committedTimer = null;

    componentDidUpdate(prevProps) {
        if (prevProps.lastSavedAt !== this.props.lastSavedAt && this.props.lastSavedAt) {
            clearTimeout(this._savedTimer);
            this.setState({ showSaved: true });
            this._savedTimer = setTimeout(() => this.setState({ showSaved: false }), 1000);
        }
        if (prevProps.lastCommittedAt !== this.props.lastCommittedAt && this.props.lastCommittedAt) {
            clearTimeout(this._committedTimer);
            this.setState({ showCommitted: true });
            this._committedTimer = setTimeout(() => this.setState({ showCommitted: false }), 1000);
        }
    }

    componentWillUnmount() {
        clearTimeout(this._savedTimer);
        clearTimeout(this._committedTimer);
    }

    render() {
        const {
            exec, fontFamily, onFontChange, lineHeight, onLineHeightChange, wordCount, onClearFormatting,
            saving, committingToHistory, timerControl,
        } = this.props;
        const { showSaved, showCommitted } = this.state;

        return (
            <div className="editor-toolbar" role="toolbar">
                <button className="btn subtle" title="Undo" onClick={() => exec("undo")}><Icon.Undo /></button>
                <button className="btn subtle" title="Redo" onClick={() => exec("redo")}><Icon.Redo /></button>

                <button className="btn subtle" title="Bold" onClick={() => exec("bold")}>B</button>
                <button className="btn subtle" title="Italic" onClick={() => exec("italic")}><i>I</i></button>
                <button className="btn subtle" title="Underline" onClick={() => exec("underline")}><u>U</u></button>

                <button className="btn subtle" title="Align left" onClick={() => exec("justifyLeft")}><Icon.AlignLeft /></button>
                <button className="btn subtle" title="Align center" onClick={() => exec("justifyCenter")}><Icon.AlignCenter /></button>
                <button className="btn subtle" title="Align right" onClick={() => exec("justifyRight")}><Icon.AlignRight /></button>

                <select aria-label="Font family" title="Font family" className="toolbar-select" value={fontFamily} onChange={onFontChange}>
                    <option value="inherit">System</option>
                    <option value="Georgia, serif">Georgia</option>
                    <option value="'Times New Roman', Times, serif">Times New Roman</option>
                    <option value="Arial, Helvetica, sans-serif">Arial</option>
                    <option value="'Trebuchet MS', sans-serif">Trebuchet MS</option>
                    <option value="Verdana, Geneva, sans-serif">Verdana</option>
                    <option value="'Courier New', Courier, monospace">Courier New</option>
                    <option value="Inter, system-ui, sans-serif">Inter</option>
                    <option value="Roboto, system-ui, sans-serif">Roboto</option>
                </select>

                <select aria-label="Line spacing" title="Line spacing" className="toolbar-select" value={lineHeight} onChange={onLineHeightChange} style={{ width: 70 }}>
                    <option value="1">1.0</option>
                    <option value="1.15">1.15</option>
                    <option value="1.5">1.5</option>
                    <option value="2">2.0</option>
                </select>

                <button className="btn subtle" title="Clear formatting" onClick={onClearFormatting}><Icon.Eraser /></button>

                <div className="word-counter-inline" title="Word count">
                    <span className="word-counter-label">Words</span>
                    <span className="word-counter">{wordCount}</span>
                </div>

                {(saving || showSaved) && (
                    <span className="editor-save-status" aria-live="polite">
                        {saving ? 'Saving…' : 'Saved'}
                    </span>
                )}
                {(committingToHistory || showCommitted) && (
                    <span className="editor-save-status editor-save-status--committed" aria-live="polite">
                        {committingToHistory ? 'Committing…' : 'Committed'}
                    </span>
                )}

                <div className="spacer" />

                <div className="editor-toolbar-timer-slot">
                    {timerControl}
                </div>

            </div>
        );
    }
}
